import * as types from "./actionTypes";

//to change the page
export const menuTypeAction = (id) => ({
    type: types.MENU_TYPE,
    payload: id
});

//mobile verification request 
export const mobileVerification_Request = (requestobj) => ({
    type: types.MOBILE_VERIFICATION_REQUEST,
    payload: requestobj,
    loadingType: types.SET_LOADING2,
    loadPayload: true
});

//mobile verification response
export const mobileVerification_Response = (status, patientId, preferredLanguage, errorMessage) => ({
    type: types.MOBILE_VERIFICATION_RESPONSE,
    payload: { status, patientId, preferredLanguage, errorMessage },
    loadingType: types.SET_LOADING2,
    loadPayload: false
});

//QRcode verification request
export const qrcodeVarificationRequest = (action) => ({
    type: types.QRCODE_VERIFICATION_REQUEST,
    payload: action,
    loadingType: types.SET_LOADING2,
    loadPayload: true
});

//QRcode verification response
export const QrcodeVarificationResponse = (status, patientId, preferredLanguage, errorMessage) => ({
    type: types.QRCODE_VERIFICATION_RESPONSE,
    payload: { status, patientId, preferredLanguage, errorMessage },
    loadingType: types.SET_LOADING2,
    loadPayload: false
});

export const emiratesId_Request = () => ({
    type: types.EMIRATESID_REQUEST,
    loadingType: types.SET_LOADING2,
    loadPayload: true
});

export const emiratesId_Response = (data, emiratesId, errorMessage) => ({
    type: types.EMIRATESID_RESPONSE,
    payload: { data, emiratesId, errorMessage },
    // loadingType: types.SET_LOADING2,
    // loadPayload: false
});

export const emiratesVerification_Request = (requestobj, verifyType) => ({
    type: types.EMIRATES_VERIFICATION_REQUEST,
    payload: { requestobj, verifyType },
    loadingType: types.SET_LOADING2,
    loadPayload: true
});

export const emiratesVerification_Response = (status, patientId, preferredLanguage, errorMessage) => ({
    type: types.EMIRATES_VERIFICATION_RESPONSE,
    payload: { status, patientId, preferredLanguage, errorMessage },
    loadingType: types.SET_LOADING2,
    loadPayload: false
});

export const language_Request = (language, patientId) => ({
    type: types.SELECTION_LANGUAGE_REQUEST,
    payload: { language, patientId },
    loadingType: types.SET_LOADING2,
    loadPayload: true
});

export const language_Response = (language, errorMessage) => ({
    type: types.SELECTION_LANGUAGE_RESPONSE,
    payload: { language, errorMessage },
    loadingType: types.SET_LOADING2,
    loadPayload: false
});

export const exitActionKiosk = () => ({
    type: types.SETRESET_ACTION
});
export const loadingAction = (loading) => ({
    type: types.SET_LOADING2,
    payload:loading
});

export const appointmentsRequest = (branchTypeCode) => {
    return {
        type: types.APPOINTMENTS_REQUEST,
        payload: branchTypeCode,
        loadingType: types.SET_LOADING2,
        loadPayload: true
    };
};

export const appointmentsResponse = (appointmentsData, errorMessage) => {
    return {
        type: types.APPOINTMENTS_RESPONSE,
        payload: { appointmentsData, errorMessage },
        loadingType: types.SET_LOADING2,
        loadPayload: false
    };
};

export const printTockendataRequest = (templateData) => {
    return {
        type: types.PRINT_TOCKEN_REQUEST,
        payload: templateData
    }
};

export const printTockendataResponse = (status) => {
    return {
        type: types.PRINT_TOCKEN_RESPONSE,
        payload: { status }
    }
};

export const checkInReprint = (tokenData) => {
    return {
        type: types.CHECKIN_REPRINT_TOCKEN,
        payload: tokenData
    }
};

export const generateCheckInToken_Request = (tokentype, Id) => {
    return {
        type: types.GENERATE_CHECKIN_TOKEN_REQUEST,
        payload: { tokentype, Id },
        loadingType: types.SET_LOADING2,
        loadPayload: true
    }
};
export const generateCheckInToken_Response = (tokenData, tokenType, appointmentsData, errorMessage) => {
    return {
        type: types.GENERATE_CHECKIN_TOKEN_RESPONSE,
        payload: { tokenData, tokenType, appointmentsData, errorMessage },
        loadingType: types.SET_LOADING2,
        loadPayload: false
    }
};
export const generateOtherServicesToken_Request = (tokentype, Id, mobileNo?) => {
    return {
        type: types.GENERATE_OTHERSERVICES_TOKEN_REQUEST,
        payload: { tokentype, Id, mobileNo },
        loadingType: types.SET_LOADING2,
        loadPayload: true
    }
};
export const generateOtherServicesToken_Response = (tokenData, tokenType, errorMessage) => {
    return {
        type: types.GENERATE_OTHERSERVICES_TOKEN_RESPONSE,
        payload: { tokenData, tokenType, errorMessage },
        loadingType: types.SET_LOADING2,
        loadPayload: false
    }
};
export const rePrintToken_Request = (tokentype, Id) => {
    return {
        type: types.REPRINT_TOCKEN_REQUEST,
        payload: { tokentype, Id },
        loadingType: types.SET_LOADING2,
        loadPayload: true
    }
};
export const rePrintToken_Response = (tokenData, tokenType, errorMessage) => {
    return {
        type: types.REPRINT_TOCKEN_RESPONSE,
        payload: { tokenData, tokenType, errorMessage },
        loadingType: types.SET_LOADING2,
        loadPayload: false
    }
};

export const kioskIdAndGetTokensDataRequest = (kioskIdentifier, action,t='') => {
    if (action)
        return {
            type: types.KIOSK_ID_AND_GET_MENUS_DATA_REQUEST,
            payload: { kioskIdentifier, action,t },
            loadingType: types.SET_LOADING2,
            loadPayload: true
        }
    else
        return {
            type: types.KIOSK_ID_AND_GET_MENUS_DATA_REQUEST,
            payload: { kioskIdentifier, action,t }
        }
};
export const KioskIdAndGetMenusDataResponse = (kioskId, welcomeMenus, otherServicesMenu, errorMessage, kioskStartTime, kioskEndTime, kioskIdentifier, locationId, logInMenus, kioskConfigData, isNewPatientRegistration, isWalkin, actiontype,selectedPage) => {
    if (actiontype)
        return {
            type: types.KIOSK_ID_AND_GET_MENUS_DATA_RESPONSE,
            payload: { kioskId, welcomeMenus, otherServicesMenu, errorMessage, kioskStartTime, kioskEndTime, kioskIdentifier, locationId, logInMenus, kioskConfigData, isNewPatientRegistration, isWalkin,actiontype,selectedPage },
            loadingType: types.SET_LOADING2,
            loadPayload: false
        }
    else
        return {
            type: types.KIOSK_ID_AND_GET_MENUS_DATA_RESPONSE,
            payload: { kioskId, welcomeMenus, otherServicesMenu, errorMessage, kioskStartTime, kioskEndTime, kioskIdentifier, locationId, logInMenus, kioskConfigData, isNewPatientRegistration, isWalkin,actiontype,selectedPage }
        }
};


export const selectedAppointAction = (apptype) =>
({
    type: types.SELECTED_APPOIN_TYPE,
    payload: apptype
});


export const getCurrentTimeRequest = () => {
    return {
        type: types.GET_CURRENT_TIME_REQUEST
    }
}

export const mobileNumberAction = (mobile) => {
    return {
        type: types.MOBILENUMBER,
        payload: mobile
    }
}

export const getCurrentTimeResponse = (dataTime) => {
    return {
        type: types.GET_CURRENT_TIME_RESPONSE,
        payload: dataTime
    }
}

export const setPromotionalDataRequest = () => {
    return {
        type: types.GET_PROMOTIONAL_FILES_REQUEST,
    }
}
export const setPromotionalDataResponse = (files) => {
    return {
        type: types.GET_PROMOTIONAL_FILES_RESPONSE,
        payload: files
    }
}
export const setNewpatientLanguageSelection = (language,selectedPage) => {
    return {
        type: types.NEW_PATIENT_LANGUAGE_SELECTION,
        payload: {language,selectedPage}
    }
}











